<template>
  <div class="main-container">
   \
    <div class="emp-header margintop-8">
      <div class="text">
        <b>Organisation Information</b>
      </div>
      <div class="line"></div>
      <br>
    </div>
    <div class="twoColumnGrid">
      <div class="left-grid">
        <img src>
        <label class="medium-font">TeamLease Service Ltd</label>
        <div class="header-text">
          <h3>Head Office</h3>
          <div class="addr">
            <label>
              Opp Wilson Pen, 115, 4th Floor, Raaj Chambers, Old Nagardas Road, Paramhans Marg, Andheri East, Mumbai,
              Maharashtra 400069
            </label>
          </div>
        </div>
        <div class="group-btn">
          <btn-grp>
            <btn text="Edit" type="secondary"/>
            <!-- <btn :text="btnText" type="primary" v-on:click="save"></btn> -->
          </btn-grp>
        </div>
      </div>
    </div>
    <!-- Tab Details Html -->
      <tl-tabs :tabs="tabs">
        <tl-tab v-for="(tab,index) of tabs" ref="tab" :key="index">
           <sub-org-details :headerTab="tab.header" :legalEntity="le_entities[index]"/>
        </tl-tab>
      </tl-tabs>
  </div>
</template>

<script>
import {mapActions} from "vuex"
import subOrgDetails from "./suborgDetails.vue";
export default {
  components: { subOrgDetails },
  data() {
    return {
      orgid: "d23da995-2dc4-4abf-bbaa-fcab5fcd696c",
      le_entities:[],
      tabs:[],
      breadcrumbList:[
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/organisation`
        },
        {
          name: "Org Details",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/orgetails`
        }
      ],
    };
  },
   activated:function(){
      this.fetchLegalEntities();
  },
  methods: {
    ...mapActions({
      fetch: 'onboard/legal_entities/fetchAll'
    }),
    routeToMainStep() {
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation`
      })
    },
      async fetchLegalEntities() {
      try {
        let res = await this.fetch(this.orgid);
        this.le_entities = res.data;
        //console.log('res',res.data);
        if(res.data.length){
          for(let entity of this.le_entities){
            this.tabs.push({
              header:entity.name
            })
          }
        }
      } catch (err) {
        //console.log('intro error', err);
        // this.leData=false
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/components/margins.scss"; 
.emp-header {
  padding: 20px 0px;
  display: flex;
  .text {
    font-size: 16px;
    color: #646464;
    margin-right: 10px;
  }
  .line {
    border-bottom: 1px solid #34c0be;
    flex-grow: 1;
  }
}
.header-text {
  font-size: 16px;
  margin: 35px 0px 10px 0px;
  color: #646464;
  .addr label {
    line-height: 30px;
  }
}
.group-btn{
  margin: 30px 0px;
}
.medium-font {
  color: #6e6e6e;
  font-size: 14px;
  font-weight: 500;
}
</style>


